
import head from "../mixins/MetaHead"
import { termsContent } from "../fc/Constants/terms-content";

export default {
    mixins: [head],
    computed: {
        termsContent() {
            return termsContent(this)
        }
    },
    data() {
        return {
            title: 'Online Converter - Convert Image, Video, Audio, & Document Files',
            desc:
                'Free online file Converter to convert your image, video, document, and music files from one format to another.',
            currentUrl: '/terms'
        }
    },
    methods: {
        getCamel(str) {
            return str ? str.toLowerCase().split(/[\s\/]+/).join('-') : ''
        }
    },
    mounted() {
        this.$store.commit('updateBreadcrumbs', [
            {
                url: this.localePath('/terms'),
                label: this.$t('terms_of_service')
            }
        ])
    }
}
